export default __webpack_public_path__ + "static/media/creator_ic_loading.2d9bae94.png";